import { render, staticRenderFns } from "./maituzidian.vue?vue&type=template&id=d24a698e&"
import script from "./maituzidian.vue?vue&type=script&lang=ts&"
export * from "./maituzidian.vue?vue&type=script&lang=ts&"
import style0 from "./maituzidian.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports